import React, { ChangeEvent } from 'react'
import { Button } from '@/components/ui/button'
import { TradingAccountDto } from 'api/Clients/Types/TradingAccount'
import {
  FormBaseButtonContainer,
  FormBaseContainer,
  FormBaseErrorMessage,
  FormBaseFieldBlock,
  FormBaseFieldGroup,
  FormBaseFieldLabel,
  FormBaseRow,
} from 'components/Form/Form.styles'
import { Field, Form, FormikErrors, FormikProps, withFormik } from 'formik'

export interface ReverseTransactionEquityFormValues {
  comment: string
}

interface OuterProps {
  selectedTradingAccounts: TradingAccountDto[]

  onSubmit(values: ReverseTransactionEquityFormValues): void
}

const TransactionNegativeEquityFormUI: React.FC<FormikProps<ReverseTransactionEquityFormValues>> = (
  props
) => {
  const { handleSubmit, isSubmitting, errors } = props

  const handleSubmitForm = (event: ChangeEvent<HTMLFormElement>) => {
    event.preventDefault()
    handleSubmit()
  }

  return (
    <FormBaseContainer>
      <Form onSubmit={handleSubmitForm}>
        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>Comment</FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <Field
                name='comment'
                placeholder='Enter comment'
                rows='3'
                maxLength='130'
                component='textarea'
                data-test='comment-field'
              />
            </FormBaseFieldGroup>
          </FormBaseRow>
          {errors.comment && <FormBaseErrorMessage>{errors.comment}</FormBaseErrorMessage>}
        </FormBaseFieldBlock>
        <FormBaseButtonContainer>
          <Button type='submit' disabled={isSubmitting}>
            Submit
          </Button>
        </FormBaseButtonContainer>
      </Form>
    </FormBaseContainer>
  )
}

export const TransactionNegativeEquityForm = withFormik<
  OuterProps,
  ReverseTransactionEquityFormValues
>({
  handleSubmit: async (values, { props, setSubmitting }) => {
    await props.onSubmit(values)
    setSubmitting(false)
  },
  validate: (values) => {
    const errors: FormikErrors<ReverseTransactionEquityFormValues> = {}
    if (!values.comment) {
      errors.comment = 'required'
    }
    return errors
  },
  isInitialValid: false,
  enableReinitialize: true,
})(TransactionNegativeEquityFormUI)
